import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, Content, Platform, ToastController } from 'ionic-angular';
import { PhotoLibrary } from './../../../providers/my-photo-library';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { CallNumber } from '@ionic-native/call-number';
import { AbstractPage } from '../../_com/abstract-page';
import { ChatAction } from '../../../actions/chat.action';
import { ReserveAction } from '../../../actions/reserve.action';
import { PhotoAction, _PhotoAction } from '../../../actions/photo.action';
import { Subscription } from 'rxjs/Subscription';
import Utils from '../../../_com/utils';
import { BasicState } from '../../../states/basic-state';
import _ from 'underscore';
import { HttpChatProvider } from '../../../providers/http-chat';
import { HttpChildProvider } from '../../../providers/http-child';

/**
 * Generated class for the ReserveDetailPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-reserve-messagesheet',
  templateUrl: 'reserve-messagesheet.html',
})
export class MessageSheetPage extends AbstractPage{

  data:any;
  chatText:String;
  chatList:any;
	child = {};
  family = {};
  reserveHistory = null;
  reservePhotos = null;
  isSaved=false;
  _utils = Utils;
  path = "";
  captureData$:Subscription;
  captureDatas$:Subscription;
  onChangeChildDetail:Subscription;

  photoAction:_PhotoAction;

  @ViewChild(Content) content: Content;
  constructor(
  	public navCtrl: NavController,
  	public navParams: NavParams,
    public chatAction:ChatAction,
    public reserveAction:ReserveAction,
    public tmpPhotoAction:PhotoAction,
    private pv:PhotoViewer,
    private pl:PhotoLibrary,
    private toastController:ToastController,
    private plt:Platform,
    private callNumber:CallNumber,
    private basicState:BasicState,
    private httpChildProvider:HttpChildProvider,
    private httpChatProvider:HttpChatProvider,
  	) {
    super();

    this.photoAction = tmpPhotoAction.getInstance();
  	this.child = this.navParams.data.child.Child;
    this.family = this.navParams.data.family;

    this.pl;  //for TSLint
    this.pv;  //for TSLint
    this.plt;  //for TSLint
    this.callNumber;  //for TSLint

    this.getData();


    /**
     * 子供情報が更新されたイベント
     */
    this.onChangeChildDetail = this.basicState.onChangeChildDetail.subscribe((data)=>{
      // this.dataReload(this.data["id"]);
    })
    // this.showMessengerKeyboard();
  }

  /**
   * データ取得
   */
  getData(){

    //予約履歴データ取得
    this.httpChildProvider.getReserveHistory({id:this.child["id"]}).subscribe((data)=>{

      this.reserveHistory = data.data;
      var reserveIds = this.reserveAction.getReserveIds(this.reserveHistory);
      this.httpChatProvider.getListHasPhotos(reserveIds).subscribe((data2)=>{
        this.reservePhotos = data2.data;
      })
    });
  }

  /**
   * 入力した内容を保存する
   */
  save() {
    this.toast(this.toastController, "体調不良・怪我連絡の作成が完了しました");
    this.isSaved = true;
  }

}



// WEBPACK FOOTER //
// ./src/pages/reserve/messagesheet/reserve-messagesheet.ts